// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.form-container {
  max-width: 720px;
  margin: 40px auto;
  padding: 32px 40px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.12);
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif;
  color: #0f172a;
}

/* Header */
.step-header {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
}

.step-subtitle {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 24px;
}

/* Progress bar */
.progress-bar-wrapper {
  width: 100%;
  background: #e2e8f0;
  border-radius: 999px;
  height: 8px;
  margin-bottom: 24px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #2563eb, #22c55e);
  width: 0%;
  transition: width 300ms ease-out;
}

/* Step indicator */
.step-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}

.step {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: 2px solid #cbd5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #64748b;
  background: #f8fafc;
  transition: all 200ms ease-out;
}

.step.active {
  border-color: #2563eb;
  background: #2563eb;
  color: #ffffff;
}

.step.completed {
  border-color: #22c55e;
  background: #22c55e;
  color: #ffffff;
}

/* Form sections */
.form-section {
  margin-top: 8px;
  animation: fadeSlideIn 250ms ease-out;
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Labels & inputs */
label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
  margin-top: 12px;
  margin-bottom: 4px;
}

.input-field {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  font-size: 14px;
  outline: none;
  transition: border-color 150ms ease-out, box-shadow 150ms ease-out;
}

.input-field:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.25);
}

/* Buttons */
.button-primary {
  margin-top: 24px;
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.35);
  transition: transform 120ms ease-out, box-shadow 120ms ease-out, background 120ms ease-out;
}

.button-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 30px rgba(37, 99, 235, 0.4);
}

.button-primary:active {
  transform: translateY(0);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.3);
}

/* Error text */
.error-text {
  color: #b91c1c;
  background: #fee2e2;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  margin-bottom: 12px;
}

/* Section headings */
.form-section h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.form-section h3 {
  font-size: 14px;
  font-weight: 600;
  margin-top: 16px;
  margin-bottom: 4px;
}

/* Paragraphs */
.form-section p {
  font-size: 14px;
  color: #475569;
  margin-top: 4px;
}

/* Completed state */
.form-section.completed-message h2 {
  font-size: 20px;
}

.form-section.completed-message p {
  font-size: 14px;
  color: #475569;
}`, "",{"version":3,"sources":["webpack://./src/css/orgRegister.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,oFAAoF;EACpF,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,SAAS;EACT,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+CAA+C;EAC/C,0FAA0F;AAC5F;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* Container */\n.form-container {\n  max-width: 720px;\n  margin: 40px auto;\n  padding: 32px 40px;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.12);\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"SF Pro Text\", sans-serif;\n  color: #0f172a;\n}\n\n/* Header */\n.step-header {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.step-subtitle {\n  font-size: 14px;\n  color: #64748b;\n  margin-bottom: 24px;\n}\n\n/* Progress bar */\n.progress-bar-wrapper {\n  width: 100%;\n  background: #e2e8f0;\n  border-radius: 999px;\n  height: 8px;\n  margin-bottom: 24px;\n  overflow: hidden;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #2563eb, #22c55e);\n  width: 0%;\n  transition: width 300ms ease-out;\n}\n\n/* Step indicator */\n.step-indicator {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.step {\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  border: 2px solid #cbd5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: #64748b;\n  background: #f8fafc;\n  transition: all 200ms ease-out;\n}\n\n.step.active {\n  border-color: #2563eb;\n  background: #2563eb;\n  color: #ffffff;\n}\n\n.step.completed {\n  border-color: #22c55e;\n  background: #22c55e;\n  color: #ffffff;\n}\n\n/* Form sections */\n.form-section {\n  margin-top: 8px;\n  animation: fadeSlideIn 250ms ease-out;\n}\n\n@keyframes fadeSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Labels & inputs */\nlabel {\n  display: block;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0f172a;\n  margin-top: 12px;\n  margin-bottom: 4px;\n}\n\n.input-field {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 150ms ease-out, box-shadow 150ms ease-out;\n}\n\n.input-field:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.25);\n}\n\n/* Buttons */\n.button-primary {\n  margin-top: 24px;\n  padding: 10px 18px;\n  border-radius: 999px;\n  border: none;\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.35);\n  transition: transform 120ms ease-out, box-shadow 120ms ease-out, background 120ms ease-out;\n}\n\n.button-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 30px rgba(37, 99, 235, 0.4);\n}\n\n.button-primary:active {\n  transform: translateY(0);\n  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.3);\n}\n\n/* Error text */\n.error-text {\n  color: #b91c1c;\n  background: #fee2e2;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 13px;\n  margin-bottom: 12px;\n}\n\n/* Section headings */\n.form-section h2 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.form-section h3 {\n  font-size: 14px;\n  font-weight: 600;\n  margin-top: 16px;\n  margin-bottom: 4px;\n}\n\n/* Paragraphs */\n.form-section p {\n  font-size: 14px;\n  color: #475569;\n  margin-top: 4px;\n}\n\n/* Completed state */\n.form-section.completed-message h2 {\n  font-size: 20px;\n}\n\n.form-section.completed-message p {\n  font-size: 14px;\n  color: #475569;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
